export { default } from "./SectionFaq";
export * from "./SectionFaq";
export * from "./SectionFaq.model";
